<template>
    <div>
    <Loader />
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
    name: 'DynamicLinkRedirect',
    components: {
        Event
    },
    props: ['pid'],
    data() {
        return {
            productId:null
        }
    },
    watch: {
        loading(val,oldval) {
             if (val==false)
                this.currentProduct = this.$store.state.singleProductInfo;
    }
     },
    computed:{
    ...mapState(['loading']),

     },
    mounted() {
        
        console.log("Codice qr caricato: " +  this.pid, this.$route.params.pid, this.$route);    
        console.log("location:" + window.location.host, window.location);   
        //window.location.href = "https://bcbeg.page.link/?link=https%3A%2F%2Fnube.beghelli.it%2F%23%2Fproducts%2F" + this.pid + "&apn=it.beghelli.cablecom.connect&ibi=it.beghelli.cablecom.connect&isi=1456277170";
        
        //ufficiale per la gestione del qr con scaricamento dell'app BConnect
        //window.location.href = "https://bcbeg.page.link/?link=" + encodeURI(window.location.origin) +"%2F%23%2Fproducts%2F" + this.pid + "&apn=it.beghelli.cablecom.connect&ibi=it.beghelli.cablecom.connect&isi=1456277170";

        //link per il redirect secco alla pagina di prodotto senza far scaricare app
        window.location.href = "https://nube.beghelli.it/#/products/" + this.pid;

     }
}

</script>